import { LoggerCfgService, LoggerCfg } from "./loggerCfg.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

enum LogType {
    debug = 1,
    error = 2,
    traceActivity = 3
}

class LoggerData {
    application: string;
    component: string;
    environment: string;
    type: LogType;
    message: string;
    control: string;

    constructor(cfg: LoggerCfg, type: LogType, message: string, control: string = "") {
        this.application = cfg ? cfg.application : "unknown";
        this.component = cfg ? cfg.component : "unknown";
        this.environment = cfg ? cfg.environment : "unknown";
        this.type = type;
        this.message = message;
        this.control = control;
    }
}

@Injectable({
    providedIn: 'root'
})
export class LoggerService {
    constructor(private cfgService: LoggerCfgService, private httpClient: HttpClient) {
    }

    public async debug(message: string, control?: string): Promise<void> {
        await this.cfgService.initialized;
        let loggerData = new LoggerData(this.cfgService.getCfg(), LogType.debug, message, control);
        await this.sendLoggerData(loggerData);
    }

    public async error(message: string, control?: string): Promise<void> {
        await this.cfgService.initialized;
        let loggerData = new LoggerData(this.cfgService.getCfg(), LogType.error, message, control);
        await this.sendLoggerData(loggerData);
    }

    public async traceActivity(message: string, control?: string): Promise<void> {
        await this.cfgService.initialized;
        let loggerData = new LoggerData(this.cfgService.getCfg(), LogType.traceActivity, message, control);
        await this.sendLoggerData(loggerData);
    }

    private async sendLoggerData(data: LoggerData): Promise<void> {
        
        const cfg = this.cfgService.getCfg();
        if (!cfg || cfg.activechk === 0) {
            return Promise.resolve();
        }
        
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

        let endpoint = cfg.endpoint;
        if (endpoint) {
            try {
                await this.httpClient.post<LoggerData>(endpoint, data, httpOptions).toPromise();
            } catch (error) {
                console.log(error);
            }
        }
    }
}